<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('word.importPage.subtitle') }}</span>
        <h3 class="page-title">{{ $t('word.importPage.title') }}</h3>
      </d-col>
    </d-row>

    <word-import-page/>
  </d-container>
</template>

<script>
import Events from '_utils/events';
import WordImportPage from '../components/WordImportPage.vue';

export default {
  name: 'word-create',
  components: {
    WordImportPage,
  },
  created() {
    Events.$emit('sidebarVisible', false);
  },
};
</script>
